import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  setCurrentPatient,
  clearCurrentPatient,
} from 'store/currentPatient/actions';

import { fetchFhirLabExams } from 'store/currentPatient/actions/fhir';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchFhirLabExams.STARTED]: handleActionStart,
  [fetchFhirLabExams.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  [fetchFhirLabExams.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.labExams,
  [clearCurrentPatient]: () => initialState,
});
